import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
///home/deepikaredrouthu/Desktop/NewCrashCart/crashcart_ui/Admin/src/translations/states/options.json
const options = require('../../../../../src/translations/states/options.json')
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @CompanyUsers
 * @Company Users
 * @companyUsers
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","header":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","textAlign":"Center","globalSearchField":"true","show":true,"field":"name","fieldName":"name","mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"name","type":"text","placeholder":"Name","label":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","globalSearchField":"true","show":true,"fieldName":"name","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const Bills = (props) => {
    const [languageData, setLanguageData] = useState();
    const [rolePermission, setRolePermission] = useState();
    const [editSelectedRecord, setEditSelectedRecord] = useState(
        window.location.href.includes("edit")
    );
    const [addSelectedRecord, setAddSelectedRecord] = useState(
        window.location.href.includes("create")
    );
    const [viewSelectedRecord, setViewSelectedRecord] = useState(
        window.location.href.includes("view")
    );
    const [isOpenFormModal, setIsOpenFormModal] = useState(false);
    const [openNewUserModal, setopenNewUserModal] = useState(false);
    const [item, setItem] = useState({});
    const [newFormFields, setNewFormField] = useState([]);

    const params = useParams();
    useEffect(() => {
        let screenPermissions = RolePermissions.screenPermissions("Invoices");
        if (screenPermissions) {
            setRolePermission(screenPermissions);
        }
    }, []);

    const getDerivedStateFromProps = (props, state) => {
        let storeData = store.getState();
        let languageData =
            storeData &&
                storeData.settingsData &&
                storeData.settingsData.settings &&
                storeData.settingsData.settings.languageTranslation
                ? storeData.settingsData.settings.languageTranslation
                : "";
        return { languageData: languageData };
    };
    // componentDidMount = () => {
    //   //Screen permisions value can be edit,view, no view
    //   let screenPermissions = RolePermissions.screenPermissions('Test');
    //   if (screenPermissions) {
    //     this.setState({
    //       rolePermission: screenPermissions
    //     })
    //   }
    //   // this.getRoleListFromServer()
    // }
    const setData = (props) => {
        let rowData = {};
        if (params.id) {
            rowData["_id"] = JSON.parse(params.id);
            return rowData;
        }
    };

    const getTableFields = () => {
        let roleTypes = [
            {
                label: "All",
                value: null,
            },
            {
                label: "Admin",
                value: "Admin",
            },
            {
                label: "Super Admin",
                value: "Super Admin",
            },
            {
                label: "User",
                value: "User",
            },
        ];
        let StatusTypes = [
            {
                label: "All",
                value: null,
            },
            {
                label: "Active",
                value: "Active",
            },
            {
                label: "Inactive",
                value: "Inactive",
            },
            {
                label: "Pending",
                value: "Pending",
            },
        ];
        let data = [
            {

                width: 30,
                field: "Sno",
                label: "SNo",
                header: "SNo",
                filter: false,
                sortable: false,
                placeholder: "Search",
                show: false,
                textAlign: "center",
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "invoiceId",
                type: "text",
                placeholder: "Bill Id",
                label: "Bill Id",
                width: 90,
                addFormOrder: 1,
                editFormOrder: 1,
                header: "Bill Id",
                derivedValue: "billId=billId=undefined",
                capitalizeTableText: true,
                sortable: true,
                filter: false,
                id: "invoiceId",
                textAlign: "center",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                field: "invoiceId",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "companyName",
                type: "text",
                placeholder: "Facility Name",
                label: "Company Name",
                width: "120px",
                addFormOrder: 1,
                editFormOrder: 1,
                header: "Company Name",
                derivedValue: "companyName=companyName=undefined",
                capitalizeTableText: true,
                sortable: true,
                filter: false,
                id: "companyName",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                // isFieldRequired: "true",
                // required: true,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "left",
                show: true,
                field: "companyName",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                // fieldType: "Link",
                // style: {
                //   color: "#0e4768",
                //   cursor: "pointer",
                //   textTransform: "capitalize",
                // },
            },
            {
                name: "companyEmail",
                type: "text",
                placeholder: "Facility Email",
                label: "Company Email",
                width: "180px",
                addFormOrder: 7,
                editFormOrder: 7,
                header: "Company Email",
                derivedValue: "companyEmail=undefined",
                capitalizeTableText: false,
                sortable: true,
                isClickable: false,
                filter: true,
                actions: [],
                actionsNumber: [],
                id: "companyEmail",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                // isFieldRequired: "true",
                // required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "left",
                show: true,
                field: "companyEmail",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "amount",
                type: "text",
                placeholder: "Facility Email",
                label: "Amount",
                width: "180px",
                addFormOrder: 7,
                editFormOrder: 7,
                header: "Amount",
                derivedValue: "amount=undefined",
                capitalizeTableText: false,
                sortable: true,
                isClickable: false,
                filter: true,
                actions: [],
                actionsNumber: [],
                id: "amount",
                fieldType: 'isCountZero',
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                // isFieldRequired: "true",
                // required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "center",
                show: true,
                field: "amount",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "description",
                type: "text",
                placeholder: "Facility Email",
                label: "Description",
                width: "180px",
                addFormOrder: 7,
                editFormOrder: 7,
                header: "Description",
                derivedValue: "description=undefined",
                capitalizeTableText: false,
                sortable: true,
                isClickable: false,
                filter: true,
                actions: [],
                actionsNumber: [],
                id: "description",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                // isFieldRequired: "true",
                // required: true,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "left",
                show: false,
                field: "description",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "validateFrom",
                type: "date",
                placeholder: "created",
                label: "Validate From",
                width: "100px",
                addFormOrder: 12,
                editFormOrder: 12,
                header: "Validate From",
                derivedValue: "created=quantity=undefined",
                capitalizeTableText: false,
                sortable: false,
                actions: [],
                actionsNumber: [],
                id: "validateFrom",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "Center",
                show: true,
                dateFormat: "MM-DD-YYYY",
                field: "validateFrom",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "validateTo",
                type: "date",
                placeholder: "created",
                label: "Validate To",
                width: "100px",
                addFormOrder: 12,
                editFormOrder: 12,
                header: "Validate To",
                derivedValue: "created=quantity=undefined",
                capitalizeTableText: false,
                sortable: false,
                actions: [],
                actionsNumber: [],
                id: "validateTo",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "Center",
                show: true,
                dateFormat: "MM-DD-YYYY",
                field: "validateTo",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "numberOfStorageUnits",
                type: "Text",
                placeholder: "Created By",
                label: "Number Of Carts",
                width: 120,
                header: "Number Of Carts",
                sortable: true,
                filter: true,
                id: "numberOfStorageUnits",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: 1001,
                fieldType: "Text",
                textAlign: "center",
                show: true,
                fieldType: 'isCountZero',
                field: "numberOfStorageUnits",
                capitalizeTableText: true,
                mobile: true,
                filter: false,
                displayInSettings: true,
            },
            {
                name: "created",
                type: "date",
                placeholder: "created",
                label: "Created",
                width: "100px",
                addFormOrder: 12,
                editFormOrder: 12,
                header: "Created",
                derivedValue: "created=quantity=undefined",
                capitalizeTableText: false,
                sortable: false,
                actions: [],
                actionsNumber: [],
                id: "created",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                isFieldRequired: "false",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                textAlign: "Center",
                show: true,
                dateFormat: "MM-DD-YYYY",
                field: "created",
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
            },

        ];
        return data;
    };

    const getFormFields = () => {
        let statusTypes = [
            {
                label: "Active",
                value: "Active",
            },
            {
                label: "Inactive",
                value: "Inactive",
            },
            {
                label: "Pending",
                value: "Pending",
            },
        ];
        return [
            {
                name: "name",
                type: "text",
                placeholder: "Company Name",
                label: "Company Name",
                width: 110,
                addFormOrder: 1,
                editFormOrder: 1,
                derivedValue: "name=facilityName=undefined",
                capitalizeTableText: true,
                sortable: true,
                filter: true,
                id: "name",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                fieldType: "Link",
                style: {
                    color: "#0e4768",
                    cursor: "pointer",
                    textTransform: "capitalize",
                },
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "email",
                type: "email",
                placeholder: "email@yopmail.com",
                label: "Company Email",
                width: "150px",
                addFormOrder: 7,
                editFormOrder: 7,
                derivedValue: "email=undefined",
                capitalizeTableText: false,
                sortable: true,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "email",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "maxCarts",
                type: "text",
                placeholder: "Maximum Number of carts",
                label: "Maximum Number of carts",
                width: "130px",
                addFormOrder: 8,
                editFormOrder: 8,
                derivedValue: "maxCarts=street=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "maxCarts",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "trialPeriod",
                type: "date",
                placeholder: "Trial Period",
                label: "Trial Period",
                width: 90,
                derivedValue: "trialPeriod=undefined",
                actions: [],
                actionsNumber: [],
                id: "trialPeriod",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: null,
                fieldType: "Date",
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                disabled: true,
                show: true,
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: true,
                isEditFormHidden: true,
            },
            {
                name: "address",
                type: "text",
                placeholder: "Address",
                label: "Company Address",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "address=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "address",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "phone",
                type: "text",
                placeholder: "Company Phone",
                label: "Company Phone Number",
                width: "130px",
                addFormOrder: 10,
                editFormOrder: 10,
                derivedValue: "phone=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "phone",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "contactPersonPhone",
                type: "text",
                placeholder: "Contact Person Phone Number",
                label: "Contact Person Phone Number",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "contactPersonPhone=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "contactPersonPhone",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "contactPersonEmail",
                type: "text",
                placeholder: "email@yopmail.com",
                label: "Contact Person Email",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "contactPersonEmail=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "contactPersonEmail",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "contactPersonDesignation",
                type: "text",
                placeholder: "Contact Person Designation",
                label: "Designation of POC",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "contactPersonDesignation=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "contactPersonDesignation",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "city",
                type: "text",
                placeholder: "City",
                label: "City",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "city=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "city",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "paymentAmount",
                type: "text",
                placeholder: "Amount",
                label: "Payment Amount",
                width: "130px",
                addFormOrder: 9,
                editFormOrder: 9,
                derivedValue: "paymentAmount=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "paymentAmount",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "false",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "false",
                controllerId: null,
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "state",
                type: "dropDown",
                placeholder: "State",
                label: "State",
                width: "130px",
                addFormOrder: 10,
                editFormOrder: 10,
                derivedValue: "status=status=status=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "state",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                options: options,
                // [
                //   { label: "Active", value: "Active", color: "success" },
                //   { label: "Pending", value: "Pending", color: "warning" },
                //   { label: "InActive", value: "InActive", color: "danger" },
                //   { label: "Dismissed", value: "Dismissed", color: "info" },
                // ],
                fieldType: "dropDown",
                dependent: [],
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "status",
                type: "dropDown",
                placeholder: "Status",
                label: "Status",
                width: "130px",
                addFormOrder: 10,
                editFormOrder: 10,
                derivedValue: "state=state=status=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "status",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                options:
                    [
                        { label: "Active", value: "Active", color: "success" },
                        { label: "Pending", value: "Pending", color: "warning" },
                        { label: "InActive", value: "InActive", color: "danger" },
                        { label: "Dismissed", value: "Dismissed", color: "info" },
                    ],
                fieldType: "dropDown",
                dependent: [],
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
            {
                name: "role",
                type: "dropDown",
                placeholder: "Role",
                label: "Role",
                width: "130px",
                addFormOrder: 10,
                editFormOrder: 10,
                derivedValue: "role=role=status=undefined",
                capitalizeTableText: false,
                sortable: false,
                isClickable: false,
                filter: false,
                actions: [],
                actionsNumber: [],
                id: "role",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                isFieldRequired: "true",
                required: false,
                displayOptionsInActions: false,
                globalSearchField: "true",
                controllerId: null,
                options:
                    [
                        { label: "Admin", value: "Admin" },

                    ],
                fieldType: "dropDown",
                dependent: [],
                show: true,
                showOrHideFields: [],
                mobile: true,
                displayInSettings: true,
                isAddFormHidden: false,
                isEditFormHidden: false,
            },
        ];
    };




    const submit = async (item) => {
        setIsOpenFormModal(true);
        // await this.formModalRef.getRowData(item, 'edit');
    };
    const getMobileTableFields = () => {
        let data = [
            {
                textAlign: "center",
                width: 47,
                field: "Check Box",
                label: "Check Box",
                fieldType: "multiple",
                header: "",
                selectionMode: "multiple",
                show: true,
                mobile: true,
                displayInSettings: true,
            },
            {
                textAlign: "center",
                width: 47,
                field: "Sno",
                label: "SNo",
                header: "SNo",
                filter: false,
                sortable: false,
                placeholder: "Search",
                show: true,
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "name",
                type: "text",
                placeholder: "Name",
                label: "Name",
                header: "Name",
                width: 110,
                id: "name",
                displayinaddForm: "true",
                displayineditForm: "true",
                displayinlist: "true",
                controllerName: null,
                fieldType: "Link",
                textAlign: "Center",
                globalSearchField: "true",
                show: true,
                field: "name",
                fieldName: "name",
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "createdByName",
                type: "Text",
                placeholder: "Created By",
                label: "Created By",
                width: 120,
                header: "Created By",
                id: "createdByName",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: 1001,
                fieldType: "Text",
                textAlign: "Center",
                show: true,
                field: "createdByName",
                mobile: true,
                filter: true,
                displayInSettings: true,
            },
            {
                name: "updatedByName",
                type: "Text",
                placeholder: "Updated By",
                label: "Updated By",
                width: 120,
                header: "Updated By",
                id: "updatedByName",
                displayinlist: "true",
                fieldType: "Text",
                textAlign: "Center",
                show: true,
                filter: true,
                field: "updatedByName",
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "created",
                type: "date",
                placeholder: "Created",
                label: "Created",
                width: 90,
                header: "Created",
                derivedValue: "created=undefined",
                actions: [],
                actionsNumber: [],
                id: "created",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: null,
                fieldType: "Date",
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                textAlign: "Center",
                disabled: true,
                show: true,
                field: "created",
                mobile: true,
                displayInSettings: true,
            },
            {
                name: "updated",
                type: "date",
                placeholder: "Updated",
                label: "Updated",
                width: 90,
                header: "Updated",
                derivedValue: "updated=undefined",
                actions: [],
                actionsNumber: [],
                id: "updated",
                displayinaddForm: "false",
                displayineditForm: "false",
                displayinlist: "true",
                globalSearchField: "false",
                controllerId: null,
                fieldType: "Date",
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                textAlign: "Center",
                disabled: true,
                show: true,
                field: "updated",
                mobile: true,
                displayInSettings: true,
            },
            {
                show: true,
                textAlign: "center",
                width: 60,
                fieldType: "Actions",
                field: "Actions",
                header: "Actions",
                label: "Actions",
                filter: false,
                sortable: false,
                displayInSettings: true,
                displayinServer: "false",
                displayinlist: "true",
                displayinaddForm: "false",
                displayineditForm: "false",
                mobile: true,
            },
        ];
        return data;
    };
    const closeFormModal = async () => {
        setIsOpenFormModal(false);
    };
    // submit1 = item => {
    //   let x = companyUsersFields
    //   let objcompanyUsers = {}

    //   objcompanyUsers["_id"] = item[0]["_id"]
    //   for (let x2 of x) {
    //     objcompanyUsers[x2] = item[0][x2]
    //   }
    //   let formFields = this.getFormFields()

    //   formFields = formFields.filter(y => x.includes(y.name))

    //   this.setState({
    //     openNewUserModal: true,
    //     item: objcompanyUsers,
    //     newFormFields: formFields
    //   });
    // }

    const cancelReset = async (type) => {
        setopenNewUserModal(false);
        window.location.reload();

        // if (type == "submit") {
        // type == "submit"
        //   ?
        // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
        // }

        // : null;
    };

    const saveDataToServer = async (item, field, value) => {
        let body = item[0];
        body[field] = value;
        let userBody = Object.assign({}, body);
        // this.setState({
        //   isLoading: true
        // });
        if (body) {
            let method, apiUrl;
            method = "PUT";
            apiUrl = `${apiCalls["companyUsers"]}/${body._id}`;
            return fetchMethodRequest(method, apiUrl, userBody)
                .then(async (response) => {
                    // let sessionexpired = await localStorage.getItem('sessionexpired')
                    // if (sessionexpired === "true") {
                    //   await this.setState({ sessionExpiryModal: true })
                    // }
                    if (response && response.respCode) {
                        showToasterMessage(response.respMessage, "success");
                    } else if (response && response.errorMessage) {
                        showToasterMessage(response.errorMessage, "error");
                    }
                    // this.setState({
                    //   isLoading: false
                    // });
                })
                .catch((err) => {
                    return err;
                });
        } else {
            return;
        }
    };

    return (
        <span>
            {
                <DataTables
                    {...props}
                    getTableFields={getTableFields}
                    formFields={getFormFields}
                    //
                    addRequired={false}
                    editRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    deleteRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    viewRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    exportRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    sample={false}
                    PrintRequired={
                        rolePermission && rolePermission == "Edit" ? true : false
                    }
                    // globalSearch={'Display Name/Email'}
                    // type='Company Users'
                    // apiUrl={apiCalls.Company Users}
                    // exportRequried={true}
                    printRequried={false}
                    actionsTypes={false}
                    // [
                    // {
                    //   name: "Delete",
                    //   options: [
                    //     {
                    //       label: "Delete",
                    //       value: "Delete",
                    //       show:
                    //         rolePermission && rolePermission == "Edit" ? true : false,
                    //       multiple: true,
                    //     },
                    //   ],
                    // },

                    // {
                    //   'name': 'Block',
                    //   "options": [
                    //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
                    //   ]
                    // },
                    // {
                    //   'name': 'ResetPassword',
                    //   "options": [
                    //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
                    //   ]
                    // },
                    // {
                    //   'name': 'Submit',
                    //   'action': this.submit,
                    //   "options": [
                    //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
                    //   ]
                    // },
                    // {
                    //   name: "newModel",
                    //   action: this.submit1,
                    //   options: [
                    //     { label: "newModel", value: "newModel", show: true, multiple: false }
                    //   ]
                    // }
                    // ]}
                    // addRequried={insertAdd}
                    // editRequired={true}
                    // deleteRequired={true}
                    // viewRequired={true}
                    settingsRequired={false}
                    filterRequired={false}
                    gridRequried={false}
                    refresh={true}
                    exportToCsv={true}
                    dateSearchRequired={false}
                    searchInDateRangeField={""}
                    setData={setData}
                    editSelectedRecord={editSelectedRecord}
                    addSelectedRecord={addSelectedRecord}
                    viewSelectedRecord={viewSelectedRecord}
                    sampleFilePath={filePath["companyUsers"]}
                    globalSearch={"Bill Id / Email / Comapny Id"}
                    type="Bills"
                    routeTo={apiCalls["invoices"]}
                    displayViewOfForm="modal"
                    sideFormLeftOrRight=""
                    apiResponseKey={apiCalls["invoices"]}
                    apiUrl={apiCalls["invoices"]}
                    selectedId={params.id}
                />
            }
            {isOpenFormModal ? (
                <FormModal
                    // onRef={(ref) => (this.formModalRef = ref)}
                    formType="edit"
                    openFormModal={isOpenFormModal}
                    formFields={formFields}
                />
            ) : null}
            {openNewUserModal ? (
                <NewUserModal
                    openNewUserModal={openNewUserModal}
                    cancelReset={cancelReset}
                    item={item}
                    newFormFields={newFormFields}
                    recordId={item._id}
                    entityType="companyUsers"
                    apiUrl={apiCalls["companyUsers"]}
                />
            ) : null}
        </span>
    );
};

export default Bills;
